import { EventMarketInfo } from './EventMarketInfo';

export default EventMarketInfo;
